"use strict";

module.exports = [ '$resource', function ( $resource ) {

    let Program = $resource('/programs/:id',
        {
            id: '@id'
        },
        {
            'save': {method:'POST'},
            'update': {method: 'PATCH'}
        }
    );

    var save = Program.save;

    // Required for "easy" .save in controllers
    Program.save = function ( ...args ) {

        if( args[0].id ) {
            this.update.apply(this, args);
        } else {
            save.apply(this, args);
        }
    };

    return Program;
}];
